/* Bedtextielonline (Claude) - gedeelde werking op alle pagina's
   1. Upsell-kaartjes (productpagina): keuze uitvoering/maat -> juiste variant en prijs
   2. Suggesties in de winkelwagen: maat kiezen + toevoegen
   3. Carrousels (reviews): schuiven vanzelf, pauzeren bij aanraken, pijltjes
   4. Optienaam 'Title' tonen als 'Maat'
   5. 'Maak je set compleet': stappen en keuze van de matras
   6-7. Maat: herkennen, vergelijken en onthouden over de hele shop
   8. Kleur wisselen in de suggesties
   9. Aantal stuks bij het winkelwagen-icoon */
(function () {
  /* ---------- 0. vaste stijl: staat nu in btol-globaal.css (laadt meteen in de head) ---------- */

  /* ---------- 0b. collectiepagina's: kop (keuzehulp of gewone collectiekop) met foto als achtergrond, zoals de homepage.
     Foto van de collectie; heeft de collectie er geen, dan de sfeerfoto van de homepage. ---------- */
  (function () {
    var pogingen = 0;
    function beeld() {
      var og = document.querySelector('meta[property="og:image"]');
      var u = (og && og.content) || '';
      if (u.indexOf('/collections/') < 0) u = 'https://www.bedtextielonline.be/cdn/shop/files/Marthe_028_productlandscape_1_1752487456.jpg?width=1800';
      return u.replace(/^http:/, 'https:').replace(/^\/\//, 'https://').replace(/width=\d+/, 'width=1800');
    }
    function zet() {
      document.querySelectorAll('.btol-wiz__kop, .shopify-section--collection-banner .container').forEach(function (k) {
        if (k.__btolBg) return;
        k.style.setProperty('--btol-wiz-bg', 'url("' + beeld() + '")');
        k.__btolBg = true;
      });
    }
    /* lange collectietekst op gsm: 3 regels met 'Lees meer' (zoals bij de keuzehulp) */
    function meer() {
      document.querySelectorAll('.shopify-section--collection-banner .collection-description').forEach(function (d) {
        if (d.__btolMeer || d.closest('.btol-wiz__kop')) return;
        d.__btolMeer = true;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'btol-wiz__meer'; b.textContent = 'Lees meer'; b.hidden = true;
        b.addEventListener('click', function () { var o = d.classList.toggle('is-open'); b.textContent = o ? 'Lees minder' : 'Lees meer'; });
        d.insertAdjacentElement('afterend', b);
        function meet() { if (!d.classList.contains('is-open')) b.hidden = d.scrollHeight <= d.clientHeight + 2; }
        meet();
        window.addEventListener('resize', meet);
      });
    }
    zet(); meer();
    var t = setInterval(function () { zet(); meer(); if (++pogingen > 30) clearInterval(t); }, 400);
  })();

  /* ---------- 0c. winkelwagenpagina: leverbericht zonder emoji, in de huisstijl ---------- */
  (function () {
    var truck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
    function levering() {
      document.querySelectorAll('.cart-recap > div[style*="border-left"]').forEach(function (d) {
        d.removeAttribute('style');
        d.className = 'btol-cart-levering';
        var s = d.querySelector('span');
        if (s) s.innerHTML = s.innerHTML.replace(/📦\s?/g, '');
        d.insertAdjacentHTML('afterbegin', truck);
      });
    }
    var bezig = false;
    function plan() { if (bezig) return; bezig = true; requestAnimationFrame(function () { bezig = false; levering(); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', levering); else levering();
    if (window.MutationObserver) new MutationObserver(plan).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* ---------- 1. upsell-kaartjes ---------- */
  if (!window.__btolUpsell) {
    window.__btolUpsell = true;
    var getData = function (card) {
      if (!card.__btolData) {
        var s = card.querySelector('script[data-btol-json]');
        try { card.__btolData = JSON.parse(s.textContent); } catch (e) { card.__btolData = { groups: [] }; }
      }
      return card.__btolData;
    };
    var currentGroup = function (card) {
      var d = getData(card);
      var gs = card.querySelector('select[data-btol-group]');
      var id = gs ? gs.value : (d.groups[0] ? String(d.groups[0].id) : '');
      return d.groups.find(function (g) { return String(g.id) === id; }) || d.groups[0];
    };
    var fill = function (card) {
      var g = currentGroup(card);
      if (!g) return;
      card.querySelectorAll('select[data-btol-opt]').forEach(function (sel) {
        var i = parseInt(sel.getAttribute('data-btol-opt'), 10);
        var prev = sel.value, vals = [];
        g.variants.forEach(function (v) { if (v.o[i] != null && vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
        sel.innerHTML = '';
        vals.forEach(function (x) { var o = document.createElement('option'); o.value = x; o.textContent = x; sel.appendChild(o); });
        if (vals.indexOf(prev) > -1) sel.value = prev;
      });
    };
    var apply = function (card) {
      var g = currentGroup(card);
      if (!g) return;
      var chosen = {};
      card.querySelectorAll('select[data-btol-opt]').forEach(function (s) { chosen[s.getAttribute('data-btol-opt')] = s.value; });
      var v = g.variants.find(function (x) {
        return Object.keys(chosen).every(function (i) { return x.o[i] === chosen[i]; });
      }) || g.variants[0];
      if (!v) return;
      var idInput = card.querySelector('[data-btol-id]');
      if (idInput) idInput.value = v.id;
      var price = card.querySelector('[data-btol-price]');
      if (price) price.textContent = v.p;
      var btn = card.querySelector('[data-btol-button]');
      if (btn) btn.disabled = !v.a;
    };
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('select[data-btol-group], select[data-btol-opt]')) return;
      var card = t.closest('[data-btol-card]');
      if (!card) return;
      if (t.matches('[data-btol-group]')) fill(card);
      apply(card);
    });
  }

  /* ---------- 1b. upsell-kaartje: titel, link en foto wisselen mee met de hoekhoogte ---------- */
  if (!window.__btolUpsellKop) {
    window.__btolUpsellKop = true;
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('select[data-btol-group]')) return;
      var card = t.closest('[data-btol-card]');
      var s = card && card.querySelector('script[data-btol-json]');
      if (!s) return;
      var d; try { d = JSON.parse(s.textContent); } catch (err) { return; }
      var g = (d.groups || []).find(function (x) { return String(x.id) === String(t.value); });
      if (!g || !g.t) return;
      var titel = card.querySelector('.product-title');
      if (titel) { titel.textContent = g.t; if (g.u) titel.href = g.u; }
      var fig = card.querySelector('.horizontal-product-card__figure');
      if (fig && g.u) fig.href = g.u;
      var img = card.querySelector('.horizontal-product-card__image');
      if (img && g.img) { img.removeAttribute('srcset'); img.src = g.img; img.alt = g.t; }
    });
  }

  /* ---------- 2. winkelwagen-suggestie ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest && e.target.closest('[data-btol-cs-select]');
    if (!s) return;
    var card = s.closest('[data-btol-cs]');
    var o = s.options[s.selectedIndex];
    var knop = card.querySelector('[data-btol-cs-add]');
    if (knop) { knop.setAttribute('data-btol-cs-add', s.value); knop.disabled = !!o.disabled; }
    var p = card.querySelector('[data-btol-cs-prijs]');
    if (p && o.getAttribute('data-prijs')) p.textContent = o.getAttribute('data-prijs');
  });
  if (!window.btolCsInit) {
    window.btolCsInit = true;
    document.addEventListener('click', async function (e) {
      var knop = e.target.closest && e.target.closest('[data-btol-cs-add]');
      if (!knop) return;
      e.preventDefault();
      var tekst = knop.querySelector('.btol-cs__knop-tekst') || knop;
      knop.setAttribute('aria-busy', 'true');
      tekst.textContent = 'Toevoegen…';
      try {
        var res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(knop.getAttribute('data-btol-cs-add')), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add');
        tekst.textContent = 'Toegevoegd';
        if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname)) { location.reload(); return; }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (err) {
        knop.removeAttribute('aria-busy');
        tekst.textContent = 'Toevoegen';
      }
    });
  }

  /* ---------- 3. carrousels ---------- */
  function stap(c, richting) {
    var eerste = c.firstElementChild;
    if (!eerste) return;
    var breedte = eerste.getBoundingClientRect().width + (parseFloat(getComputedStyle(c).columnGap) || 0);
    var max = c.scrollWidth - c.clientWidth - 2;
    var doel = c.scrollLeft + richting * breedte;
    if (doel > max + 1) doel = 0;
    if (doel < -1) doel = max;
    c.scrollTo({ left: doel, behavior: 'smooth' });
  }
  setInterval(function () {
    document.querySelectorAll('[data-btol-carrousel]').forEach(function (c) {
      if (c.offsetParent === null || c.scrollWidth <= c.clientWidth + 2) return;
      if (c.matches(':hover') || (c.__btolPauze && Date.now() < c.__btolPauze)) return;
      stap(c, 1);
    });
  }, 5000);
  document.addEventListener('touchstart', function (e) {
    var c = e.target.closest && e.target.closest('[data-btol-carrousel]');
    if (c) c.__btolPauze = Date.now() + 10000;
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('[data-btol-pijl]');
    if (!p) return;
    var c = p.closest('.btol-pv__carrousel');
    c = c && c.querySelector('[data-btol-carrousel]');
    if (!c) return;
    c.__btolPauze = Date.now() + 10000;
    stap(c, parseInt(p.getAttribute('data-btol-pijl'), 10));
  });

  /* ---------- 4. optienaam 'Title' (standaardnaam van Shopify) tonen als 'Maat' bij de aanvullende producten ---------- */
  function titelMaat() {
    document.querySelectorAll('.btol-picker label > span').forEach(function (s) {
      if (s.textContent.trim().toLowerCase() === 'title') s.textContent = 'Maat';
    });
  }
  titelMaat();
  var tm = 0, tmt = setInterval(function () { titelMaat(); if (++tm > 12) clearInterval(tmt); }, 800);

  /* ---------- 5. 'Maak je set compleet' (winkelwagen): naar een stap gaan met de knopjes bovenaan.
     Na toevoegen opent vanzelf de volgende stap (de winkelwagen wordt opnieuw opgebouwd). ---------- */
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-btol-stap-knop]');
    if (!k) return;
    var box = k.closest('.btol-cz, .btol-cp-sug, .btol-cart-suggestie');
    var lijst = box && box.querySelector('[data-btol-stappen]');
    if (!lijst) return;
    e.preventDefault();
    var key = k.getAttribute('data-btol-stap-knop');
    lijst.querySelectorAll('.btol-sug__kaart').forEach(function (c) { c.classList.toggle('is-actief', c.getAttribute('data-btol-stap') === key); });
    box.querySelectorAll('[data-btol-stap-knop]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-btol-stap-knop') === key ? 'true' : 'false'); });
  });

  /* hoeslaken in de trechter: keuze standaard / extra hoog / topper (onthouden, net als op de productpagina) */
  function hhZet(kaart, g) {
    if (!kaart.querySelector('[data-btol-hh-opt="' + g + '"]')) return;
    kaart.querySelectorAll('[data-btol-hh-opt]').forEach(function (o) { o.classList.toggle('is-actief', o.getAttribute('data-btol-hh-opt') === g); });
    kaart.querySelectorAll('[data-btol-hh-knop]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-btol-hh-knop') === g ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-btol-hh-knop]');
    if (!b) return;
    e.preventDefault();
    var g = b.getAttribute('data-btol-hh-knop');
    document.querySelectorAll('[data-btol-hh]').forEach(function (k) { hhZet(k, g); });
    try { localStorage.setItem('btol_ups', g); } catch (err) {}
  });
  /* meerdere dekbedovertrekken in de winkelwagen: wisselen tussen de hoeslaken-blokken met de fotoknopjes */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-btol-voor-knop]');
    if (!b) return;
    e.preventDefault();
    var kaart = b.closest('.btol-sug__kaart'), nr = b.getAttribute('data-btol-voor-knop');
    if (!kaart) return;
    kaart.querySelectorAll('[data-btol-voor]').forEach(function (v) { v.classList.toggle('is-actief', v.getAttribute('data-btol-voor') === nr); });
    kaart.querySelectorAll('[data-btol-voor-knop]').forEach(function (k) { k.setAttribute('aria-pressed', k === b ? 'true' : 'false'); });
  });
  function hhOnthoud() {
    var g = null;
    try { g = localStorage.getItem('btol_ups'); } catch (err) {}
    if (!g) return;
    document.querySelectorAll('[data-btol-hh]').forEach(function (k) { if (!k.__btolHh) { k.__btolHh = true; hhZet(k, g); } });
  }
  hhOnthoud();
  if (window.MutationObserver) new MutationObserver(function () { hhOnthoud(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- 6. hulpfuncties voor de maat (trechter, upsell en productpagina) ---------- */
  /* een maat-tekst kan meerdere maten bevatten, bv. '140 x 200 cm - 120/130 x 200 cm' (stretch) of '240 x 200/220 cm + 2 kussenslopen' */
  function maatDelen(t) {
    t = String(t || '').toLowerCase();
    var m = t.match(/\(([^)]*)\)/); if (m) t = m[1];
    t = t.replace(/cm/g, '').replace(/×/g, 'x');
    var uit = [];
    t.split(/\s+-\s+|,|;|\s+of\s+/).forEach(function (deel) {
      var d = deel.split('+')[0].split('x'); if (d.length < 2) return;
      var b = d[0].split('/').map(function (s) { return s.trim(); }).filter(Boolean);
      var l = d[1].split('/').map(function (s) { return s.trim(); }).filter(Boolean);
      if (b.length && l.length) uit.push({ b: b, l: l });
    });
    return uit.length ? uit : null;
  }
  function maatEen(a, b) {
    return a.b.some(function (x) { return b.b.indexOf(x) > -1; }) && a.l.some(function (x) { return b.l.indexOf(x) > -1; });
  }
  /* strikt: alleen de eerste (hoofd)maat van beide vergelijken */
  function maatPast(a, b, strikt) {
    if (!a || !b) return false;
    var A = strikt ? [a[0]] : a, B = strikt ? [b[0]] : b;
    return A.some(function (x) { return B.some(function (y) { return maatEen(x, y); }); });
  }
  /* beste keuze uit een lijst: exact dezelfde tekst, dan zelfde hoofdmaat, dan overlap */
  function besteMaat(lijst, tekstVan, t) {
    var doel = maatDelen(t), schoon = String(t || '').trim();
    lijst = lijst.filter(function (x) { return !x.disabled; });
    return lijst.find(function (x) { return maatTekst(tekstVan(x)) === schoon; }) ||
           lijst.find(function (x) { return maatPast(doel, maatDelen(tekstVan(x)), true); }) ||
           lijst.find(function (x) { return maatPast(doel, maatDelen(tekstVan(x))); }) || null;
  }
  function optTekst(o) { return o.text; }
  function kaartBij(card, sel) {
    var o = sel.options[sel.selectedIndex]; if (!o) return;
    var knop = card.querySelector('[data-btol-cs-add]');
    if (knop) { knop.setAttribute('data-btol-cs-add', sel.value); knop.disabled = !!o.disabled; }
    var p = card.querySelector('[data-btol-cs-prijs]');
    if (p && o.getAttribute('data-prijs')) p.textContent = o.getAttribute('data-prijs');
  }
  function kiesMaat(sel, tekst) {
    var keuze = besteMaat(Array.prototype.slice.call(sel.options), optTekst, tekst);
    if (keuze && sel.value !== keuze.value) { sel.value = keuze.value; kaartBij(sel.closest('[data-btol-cs]'), sel); }
  }
  /* ---------- 7. maatgeheugen over de hele shop ----------
     Standaard rekenen we de maat zelf uit (bv. dekbedovertrek 260 -> hoeslaken 180 x 200).
     Kiest de klant ergens zelf een maat (productpagina, 'Maak je set compleet' op de productpagina, de trechter in de winkelwagen),
     dan onthouden we die (localStorage) en die gaat overal voor. Drie aparte geheugens:
     matras (hoeslaken, topper hoeslaken, matrasbeschermer), dekbed (dekbed en dekbedovertrek) en kussen. */
  var MAAT_KEY = { matras: 'btol_maat_matras', dekbed: 'btol_maat_dekbed', kussen: 'btol_maat_kussen' };
  var MAAT_RE = /\d+\s*(?:\/\s*\d+\s*)*[x×]\s*\d+/i;
  function domeinVanTekst(t) {
    t = String(t || '').toLowerCase();
    if (/lakenset|badlaken|handdoek|plaid|sprei/.test(t)) return null;
    if (/dekbed/.test(t)) return 'dekbed';
    if (/kussen|sloop/.test(t)) return 'kussen';
    if (/hoeslaken|beschermer|molton|topper/.test(t)) return 'matras';
    return null;
  }
  function domeinVan(el) {
    var k = el.closest('.btol-sug__kaart');
    var s = k && k.getAttribute('data-btol-stap');
    if (s === 'hoeslaken' || s === 'beschermer') return 'matras';
    if (s === 'dekbed') return 'dekbed';
    if (s === 'kussen') return 'kussen';
    var c = el.closest('[data-btol-cs], [data-btol-card]');
    var t = c && c.querySelector('.btol-cs__titel, .product-title');
    return domeinVanTekst(t ? t.textContent : '');
  }
  /* dekbed: bij een maat met 200/220 (zoals bij een dekbedovertrek) standaard de lengte 220, behalve 200 breed (200 x 200) */
  function dekbedVoorkeur(t) {
    var d = maatDelen(t); if (!d) return t;
    var m = d[0];
    if (m.l.indexOf('200') < 0 || m.l.indexOf('220') < 0) return t;
    var br = m.b[0];
    return br + ' x ' + (m.b.indexOf('200') > -1 ? '200' : '220');
  }
  function maatTekst(t) { return String(t || '').replace(/\s*\(uitverkocht\)\s*$/i, '').trim(); }
  function maatLees(d) { try { return d ? localStorage.getItem(MAAT_KEY[d]) : null; } catch (err) { return null; } }
  function maatBewaar(d, t) {
    t = maatTekst(t).split(/\s+-\s+/)[0].trim();
    if (!d || !MAAT_KEY[d] || !MAAT_RE.test(t)) return;
    try { localStorage.setItem(MAAT_KEY[d], t); } catch (err) {}
  }
  function maatOk(sel, t) {
    var beste = besteMaat(Array.prototype.slice.call(sel.options), optTekst, t);
    return !beste || beste === sel.options[sel.selectedIndex];
  }
  function maatSelect(card) {
    return Array.prototype.find.call(card.querySelectorAll('select[data-btol-opt]'), function (s) {
      return /maat|afmeting|title|size/i.test(s.getAttribute('aria-label') || '');
    });
  }
  /* klant kiest zelf een maat: onthouden en de andere kaartjes van hetzelfde soort meteen mee laten gaan */
  document.addEventListener('change', function (e) {
    if (!e.isTrusted || !e.target || !e.target.closest) return;
    var t = e.target, d = null, tekst = '';
    if (t.matches('[data-btol-cs-select]')) {
      d = domeinVan(t); tekst = t.options[t.selectedIndex] ? t.options[t.selectedIndex].text : '';
    } else if (t.matches('select[data-btol-opt]') && t.closest('[data-btol-card]') && maatSelect(t.closest('[data-btol-card]')) === t) {
      d = domeinVan(t); tekst = t.options[t.selectedIndex] ? t.options[t.selectedIndex].text : '';
    } else if (t.closest('variant-picker[context="main_product"]')) {
      var pr = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      d = domeinVanTekst(pr ? pr.type : '');
      if (t.tagName === 'SELECT') tekst = t.options[t.selectedIndex] ? t.options[t.selectedIndex].text : '';
      else if (t.id) { var lb = document.querySelector('label[for="' + t.id + '"]'); tekst = lb ? lb.textContent : ''; }
    }
    tekst = maatTekst(tekst);
    if (!d || !MAAT_RE.test(tekst)) return;
    maatBewaar(d, tekst);
    maatToepassen();
  });
  var pdpGedaan = false, metVariant = /[?&]variant=/.test(location.search);
  function maatToepassen() {
    /* trechter en suggestiekaartjes in de winkelwagen */
    document.querySelectorAll('[data-btol-cs-select]').forEach(function (s) {
      var d = domeinVan(s), t = maatLees(d);
      if (t && d === 'dekbed') t = dekbedVoorkeur(t);
      if (t && !maatOk(s, t)) kiesMaat(s, t);
    });
    /* 'Maak je set compleet' op de productpagina */
    document.querySelectorAll('[data-btol-card]').forEach(function (card) {
      var sel = maatSelect(card); if (!sel) return;
      var d = domeinVan(sel), t = maatLees(d);
      if (t && d === 'dekbed') t = dekbedVoorkeur(t);
      if (!t || maatOk(sel, t)) return;
      var hit = besteMaat(Array.prototype.slice.call(sel.options), optTekst, t);
      if (!hit) return;
      sel.value = hit.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
    /* productpagina zelf: een keer bij het openen, niet als er al een variant in de link staat (bv. vanuit Google) */
    if (!pdpGedaan && !metVariant) {
      var vp = document.querySelector('variant-picker[context="main_product"]');
      var pr = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (vp && pr) {
        pdpGedaan = true;
        var pd = domeinVanTekst(pr.type), t = maatLees(pd);
        if (!t) return;
        if (pd === 'dekbed' && !/overtrek/i.test(pr.type)) t = dekbedVoorkeur(t);
        vp.querySelectorAll('fieldset').forEach(function (f) {
          var radios = Array.prototype.slice.call(f.querySelectorAll('input[type="radio"]'));
          var lab = function (i) { var l = f.querySelector('label[for="' + i.id + '"]'); return l ? maatTekst(l.textContent) : ''; };
          if (!radios.length || !radios.some(function (i) { return MAAT_RE.test(lab(i)); })) return;
          var hit = besteMaat(radios, lab, t);
          if (hit && !hit.checked) hit.click();
        });
        vp.querySelectorAll('select').forEach(function (s) {
          if (!Array.prototype.some.call(s.options, function (o) { return MAAT_RE.test(o.text); }) || maatOk(s, t)) return;
          var o = besteMaat(Array.prototype.slice.call(s.options), optTekst, t);
          if (o) { s.value = o.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }
    }
  }
  /* oude sessie-sleutel van de trechter overnemen */
  try { var oud = sessionStorage.getItem('btol_matras'); if (oud && !localStorage.getItem(MAAT_KEY.matras)) maatBewaar('matras', oud); sessionStorage.removeItem('btol_matras'); } catch (err) {}
  var maatBezig = false;
  function maatPlan() { if (maatBezig) return; maatBezig = true; setTimeout(function () { maatBezig = false; maatToepassen(); }, 60); }
  maatToepassen();
  document.addEventListener('DOMContentLoaded', maatPlan);
  document.addEventListener('variant:change', function () { setTimeout(maatPlan, 200); });
  if (window.MutationObserver) new MutationObserver(maatPlan).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- 8. trechter: kleur wisselen met de kleurfotootjes, extra kleuren open- en dichtklappen ---------- */
  function euro(c) { return (c / 100).toFixed(2).replace('.', ','); }
  document.addEventListener('click', async function (e) {
    var meer = e.target.closest && e.target.closest('[data-btol-kleur-meer]');
    if (meer) {
      e.preventDefault();
      var kl = meer.closest('[data-btol-kleuren]'), open = kl.classList.toggle('is-open');
      if (!meer.getAttribute('data-dicht')) meer.setAttribute('data-dicht', meer.textContent);
      meer.textContent = open ? 'Minder kleuren' : meer.getAttribute('data-dicht');
      return;
    }
    var b = e.target.closest && e.target.closest('[data-btol-kleur]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('[data-btol-cs]');
    if (!card || b.classList.contains('is-actief')) return;
    var sel = card.querySelector('[data-btol-cs-select]');
    var huidig = sel ? sel.options[sel.selectedIndex].text : '';
    card.setAttribute('aria-busy', 'true');
    try {
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var p = await fetch(root + 'products/' + b.getAttribute('data-btol-kleur') + '.js').then(function (r) { return r.json(); });
      var url = root + 'products/' + p.handle;
      card.querySelectorAll('.btol-cs__beeld, .btol-cs__titel').forEach(function (a) { a.setAttribute('href', url); });
      var titel = card.querySelector('.btol-cs__titel'); if (titel) titel.textContent = p.title;
      var img = card.querySelector('.btol-cs__beeld img');
      if (img && p.featured_image) { img.removeAttribute('srcset'); img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240'; img.alt = p.title; }
      var knop = card.querySelector('[data-btol-cs-add]');
      var prijs = card.querySelector('[data-btol-cs-prijs]');
      if (sel) {
        sel.innerHTML = '';
        p.variants.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id; o.textContent = v.title + (v.available ? '' : ' (uitverkocht)'); o.disabled = !v.available; o.setAttribute('data-prijs', euro(v.price));
          sel.appendChild(o);
        });
        var eerste = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        sel.value = eerste.id;
        kiesMaat(sel, huidig);
        kaartBij(card, sel);
      } else {
        var v1 = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        if (knop) { knop.setAttribute('data-btol-cs-add', v1.id); knop.disabled = !v1.available; }
        if (prijs) prijs.textContent = euro(v1.price);
      }
      card.querySelectorAll('[data-btol-kleur]').forEach(function (k) { k.classList.toggle('is-actief', k === b); });
    } catch (err) {}
    card.removeAttribute('aria-busy');
  });

  /* ---------- 9. winkelwagen-icoon: aantal stuks in het bolletje ---------- */
  var aantal = null;
  function aantalZet(n) {
    if (typeof n === 'number') aantal = n > 99 ? '99+' : String(n);
    if (aantal === null) return;
    document.querySelectorAll('cart-dot').forEach(function (d) { if (d.getAttribute('data-aantal') !== aantal) d.setAttribute('data-aantal', aantal); });
  }
  function aantalHaal() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { aantalZet(c.item_count); }).catch(function () {});
  }
  aantalHaal();
  document.addEventListener('cart:change', function (e) {
    var c = e.detail && e.detail.cart;
    if (c && typeof c.item_count === 'number') aantalZet(c.item_count); else aantalHaal();
  });
  document.addEventListener('cart:refresh', function () { setTimeout(aantalHaal, 400); });
  if (window.MutationObserver) new MutationObserver(function () { aantalZet(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
